// export const API_URL = "http://localhost:5000";

// Prod
export const API_URL = "https://api.prod.trux.szvp2024.com";


// Dev
// export const API_URL = "https://api.prod.trux.szvp2024.com";
// export const API_URL = "http://127.0.0.1:5000";
